import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "reactstrap";
import SecondaryHeader from "../../../../Layouts/SecondaryHeader";
import Sidebar from "./PosSidebar";
import OrderSummary from "../../page/OrderSummary/OrderSummary";
import ProductPage from "../../page/ProductPage/ProductPage";
import ProductItemServices from "../../../../services/OrderingServices/ProductItemService";
import toast from "react-hot-toast";
import OrderServices from "../../../../services/OrderingServices/OrderServices";
import TableService from "../../../../services/OrderingServices/TableService";
import SectionService from "../../../../services/OrderingServices/SectionService";
import OrderSummaryModal from "../../page/OrderSummary/OrderSummaryMobile";
import {
  addOrderItem,
  resetOrder,
  resetTableOrder,
  setApiOrderData,
  setOrderData,
  setPlacedOrder,
} from "../../../../slices/Order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import KOTService from "../../../../services/OrderingServices/KOTService";

const PosLayout = () => {
  const dispatch = useDispatch();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedTable, setSelectedTable] = useState(() => {
    try {
      const item = localStorage.getItem("selectedTable");
      return item && item !== "undefined" ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  });
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [selectedChildAttributes, setSelectedChildAttributes] = useState([]);
  const [isTableOpen, setIsTableOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [complementary, setComplementary] = useState(false);
  const [count, setCount] = useState(1);
  const [complementaryCount, setComplimentaryCount] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileOrder, setIsMobileOrder] = useState(false);
  const [billsData, setBillsData] = useState();
  const [data, setData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [orderId, setOrderId] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [itemCounts, setItemCounts] = useState({});
  const [responseOrder, setResponseOrder] = useState([]);
  const [allTables, setAllTables] = useState([]);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const shouldShowSections = user?.shouldShowSections;
  const orderData = useSelector((state) => {
    return state.order.orderData;
  });

  console.log("🚀 ~ PosLayout ~ orderData:", orderData);
  const [isQuantityChanged, setIsQuantityChanged] = React.useState(false);
  const [kotList, setKotList] = useState([]);

  const [placedItems, setPlacedItems] = useState([]);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);
  const toggleOrderSummary = () => setIsMobileOrder(!isMobileOrder);
  const kotListRef = useRef();

  const fetchKot = async () => {
    try {
      const response = await KOTService.getList();
      setKotList(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchKot();
  }, []);

  const handleAddToCart = (item, isTakeaway = false, incrementOnly = false) => {
    console.log("🚀 ~ handleAddToCart ~ item:", item);
    const items = item?.id || selectedItem?.id;

    // Require table only if not takeaway
    if (!items || (!isTakeaway && !selectedTable?.id)) {
      toast.error(
        !items
          ? "Please select an item first."
          : "Please select a table first or choose Takeaway."
      );
      return;
    }

    // Helper to calculate total price including children + child attributes
    const computeTotalPrice = () => {
      let total = item?.price || selectedItem?.price || 0;

      (selectedChildAttributes || []).forEach((child) => {
        const childPrice = child.productPrice || 0;
        const attrsPrice = (child.attributes || []).reduce(
          (sum, attr) => sum + (attr.value || 0),
          0
        );
        total += childPrice + attrsPrice;
      });

      return total;
    };

    const updatedChildren = selectedChildAttributes?.map((child) => ({
      productId: child?.productId,
      productName: child?.productName || "",
      quantity: child?.quantity || 0,
      productPrice: child?.productPrice || 0,
      attributes: Array.isArray(child?.attributes)
        ? child?.attributes.map((attr) => ({
            title: attr?.title,
            value: attr?.value || 0,
            // spicyLevel: attr?.spicyLevel || 0,
          }))
        : [],
    }));

    const tableKey = selectedTable?.id || "takeaway";
    const currentOrder = orderData[tableKey] || {
      tableId: selectedTable?.id || null,
      remarks: "",
      items: [],
    };

    // Check if the same parent + children + attributes already exist
    const existingItemIndex = currentOrder.items.findIndex(
      (i) =>
        i.productId === (item?.id || selectedItem?.id) &&
        JSON.stringify(i.attributes) ===
          JSON.stringify(
            Object.values(selectedAttributes).map((attrGroup) => ({
              title: attrGroup.Option?.title,
              value: attrGroup.Option?.value,
              // spicyLevel: attrGroup.Option?.spicyLevel || 0,
            }))
          ) &&
        JSON.stringify(i.children) === JSON.stringify(updatedChildren)
    );

    let updatedItems;

    if (existingItemIndex >= 0) {
      // Item exists - increment quantity by 1 (or by count if from modal)
      const existingItem = currentOrder.items[existingItemIndex];
      updatedItems = [...currentOrder.items];

      const incrementBy = incrementOnly ? 1 : count;

      const newQuantity =
        existingItem.quantity + (complementary ? 0 : incrementBy);
      const newComplimentaryQty =
        existingItem.complimentaryQuantity + (complementary ? incrementBy : 0);

      console.log("🔄 Updating existing item:", {
        productName: existingItem.productName,
        oldQuantity: existingItem.quantity,
        oldComplimentary: existingItem.complimentaryQuantity,
        incrementBy,
        isComplementary: complementary,
        newQuantity,
        newComplimentaryQty,
      });

      updatedItems[existingItemIndex] = {
        ...existingItem,
        quantity: newQuantity,
        complimentaryQuantity: newComplimentaryQty,
        finalQuantity: newQuantity + newComplimentaryQty,
        note: notes || existingItem.note,
        remarks: notes || existingItem.remarks,
        isComplimentary: newComplimentaryQty > 0,
        children: updatedChildren.length
          ? updatedChildren
          : existingItem.children,
        productPrice: existingItem.productPrice, // Keep unit price
        isLocalItem: true, // ✅ ENSURE IT STAYS
      };
    } else {
      // New item
      console.log("➕ Adding new item:", {
        productName: item?.name || selectedItem?.name,
        quantity: complementary ? 0 : count,
        complimentaryQuantity: complementary ? count : 0,
        isComplementary: complementary,
      });

      const newItem = {
        productId: item?.id || selectedItem?.id,
        quantity: complementary ? 0 : count,
        complimentaryQuantity: complementary ? count : 0,
        note: notes || "",
        productName: item?.name || selectedItem?.name,
        productPrice: computeTotalPrice(),
        unitName: item?.unitName || selectedItem?.unitName,
        remarks: notes || "",
        isComplimentary: complementary,
        attributes: Object.values(selectedAttributes).map((attrGroup) => ({
          title: attrGroup.Option?.title,
          value: attrGroup.Option?.value,
          // spicyLevel: attrGroup.Option?.spicyLevel || 0,
        })),
        finalQuantity: count,
        image: item?.image || "https://via.placeholder.com/60",
        isLocalItem: true,
        children: updatedChildren,
      };

      updatedItems = [...currentOrder.items, newItem];
    }

    // Log the complete order before dispatching
    console.log("📦 Complete order being saved:", {
      tableKey,
      items: updatedItems.map((i) => ({
        name: i.productName,
        qty: i.quantity,
        compQty: i.complimentaryQuantity,
        isComp: i.isComplimentary,
      })),
    });

    dispatch(
      setOrderData({
        [tableKey]: {
          ...currentOrder,
          isNewItem: true,
          items: updatedItems,
        },
      })
    );

    toast.success(
      `Item ${existingItemIndex >= 0 ? "quantity updated" : "added to cart"} ${
        complementary ? "(Complementary)" : ""
      }${isTakeaway ? " (Takeaway)" : ""}.`
    );

    setSelectedItem({});
    fetchTable();
    resetModalState();
  };

  const handlePlaceOrder = async () => {
    console.log("from handle place order...");
    const tableId = selectedTable?.id || null;
    console.log("tableId@@@@", tableId);

    let rawOrder;

    // If table is selected, get table order, otherwise check for takeaway
    if (selectedTable) {
      rawOrder = orderData[tableId];
    } else if (orderData.takeaway && orderData.takeaway.items.length > 0) {
      rawOrder = orderData.takeaway;
    } else {
      toast.error("Cart is empty.");
      return;
    }

    const formattedOrder = {
      tableId: rawOrder.tableId,
      remarks: rawOrder.remarks || "",
      items: rawOrder.items.map((item, index) => {
        const itemKey = `${tableId}-${index}`;

        // CRITICAL FIX: Check if quantity was manually changed
        const hasManualQuantityChange = itemCounts[itemKey] !== undefined;

        let finalQuantity;
        let finalComplimentaryQuantity;

        if (hasManualQuantityChange) {
          // User manually changed quantity via +/- buttons
          // This affects REGULAR quantity, NOT complementary
          finalQuantity = itemCounts[itemKey];
          finalComplimentaryQuantity = item.complimentaryQuantity || 0;
        } else {
          // No manual change - use original values from item
          finalQuantity = item.quantity || 0;
          finalComplimentaryQuantity = item.complimentaryQuantity || 0;
        }

        console.log(`Item ${index}:`, {
          productName: item.productName,
          originalQuantity: item.quantity,
          originalComplimentary: item.complimentaryQuantity,
          finalQuantity,
          finalComplimentaryQuantity,
          hasManualChange: hasManualQuantityChange,
        });

        return {
          productId: item.productId,
          quantity: finalQuantity,
          complimentaryQuantity: finalComplimentaryQuantity,
          note: item.note || "",
          remarks: item.remarks || "",
          children: Array.isArray(item.children)
            ? item.children.map((child) => ({
                productName: child.productName || "",
                quantity: child.quantity || 0,
                productPrice: child.productPrice || 0,
                attributes: Array.isArray(child.attributes)
                  ? child.attributes.map((attr) => ({
                      title: attr.title,
                      value: attr.value || 0,
                      // spicyLevel: attr.spicyLevel || 0,
                    }))
                  : [],
              }))
            : [],
          isComplimentary:
            finalComplimentaryQuantity > 0 && finalQuantity === 0,
          attributes: Array.isArray(item.attributes)
            ? item.attributes.map((attr) => ({
                title: attr.title,
                value: attr.value,
                // spicyLevel: attr.spicyLevel || 0,
              }))
            : [],
        };
      }),
    };

    try {
      setLoading(true);
      console.log(
        "🚀 ~ handlePlaceOrder ~ payload sent to backend:",
        formattedOrder
      );
      const response = await ProductItemServices.order(formattedOrder);
      if (tableId === null || tableId === "takeaway") {
        localStorage.setItem("orderId", response?.id);
      }

      const mappedOrder = {
        orderId: response.id,
        orderRefrenceId: response.orderRefrenceId,
        totalAmount: response.totalAmount,
        discountAmount: response.discountAmount,
        taxAmount: response.taxAmount,
        grandTotal: response.grandTotal,
        paymentStatus: response.paymentStatus,
        orderStatus: response.orderStatus,
        remarks: response.remarks || "",
        tableId,
        items: response.orderDetails.map((item) => ({
          id: item?.id,
          productId: item.productId,
          quantity: item.quantity,
          complimentaryQuantity: item.complimentaryQuantity,
          finalQuantity: item.quantity + item.complimentaryQuantity,
          remarks: item.remarks || "",
          isComplimentary: item.isComplimentary,
          attributes: Array.isArray(item.attributes)
            ? item.attributes.map((attr) => ({
                title: attr.title,
                value: attr.value,
                // spicyLevel: attr.spicyLevel || 0,
              }))
            : [],
          productName: item.productName,
          productPrice: item.productPrice,
          image: item.image || "https://via.placeholder.com/60",
          orderItemStatus: item?.orderItemStatus,
          printingRemainingQuantity: item?.printingRemainingQuantity,
          printedQuantity: item?.printedQuantity,
          children: Array.isArray(item.children)
            ? item.children.map((child) => ({
                productName: child.productName || "",
                quantity: child.quantity || 0,
                productPrice: child.productPrice || 0,
                attributes: Array.isArray(child.attributes)
                  ? child.attributes.map((attr) => ({
                      title: attr.title,
                      value: attr.value || 0,
                      // spicyLevel: attr.spicyLevel || 0,
                    }))
                  : [],
              }))
            : [],
        })),
      };

      dispatch(
        setOrderData({
          [tableId || "takeaway"]: mappedOrder,
        })
      );

      setIsQuantityChanged(null);
      dispatch(resetTableOrder(tableId));
      setPlacedItems([]);
      toast.success("Order created successfully.");
      fetchOrder();
      fetchTable();
      fetchAllTables()
      kotListRef.current?.refreshKot();

      const isFromApp = navigator.userAgent.includes("CloudRestroAPK");
      const isSettingMatched = true;

      if (isFromApp && isSettingMatched) {
        console.log("Running inside APK WebView");
        const userData = JSON.parse(localStorage.getItem("user") || "{}");
        const token = userData.accessToken || userData.token || null;
        console.log("This is the token: ", token);
        const printerData = { tableId: tableId, Token: token };
        const payload = encodeURIComponent(JSON.stringify(printerData));
        window.location.href = `app://printKOT?data=${payload}`;
      } else {
        console.log("Running in normal browser");
      }

      resetModalState();
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Failed to place order.");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrder = async () => {
    if (!selectedTable?.id) return;
    setLoading(true);
    setError(null);

    try {
      const response = await OrderServices.getByTable(selectedTable?.id);
      if (!response?.id) return;

      const placedItems = (response?.orderDetails || []).map((item) => ({
        id: item?.id,
        productId: item?.productId,
        quantity: item?.quantity,
        note: item?.note || "",
        remarks: item?.remarks || "",
        isComplimentary: item?.isComplimentary || false,
        attributes: Array.isArray(item?.attributes)
          ? item?.attributes?.map((attr) => ({
              title: attr?.title,
              value: attr?.value,
              // spicyLevel: attr?.spicyLevel || 0,
            }))
          : [],
        productName: item?.productName,
        productPrice: item?.productPrice,
        complimentaryQuantity: item?.complimentaryQuantity,
        finalQuantity: item?.finalQuantity,
        image: item?.image || "https://via.placeholder.com/60",
        orderItemStatus: item?.orderItemStatus,
        printingRemainingQuantity: item?.printingRemainingQuantity,
        printedQuantity: item?.printedQuantity,
        children: Array.isArray(item?.children)
          ? item?.children?.map((child) => ({
              productName: child?.productName || "",
              quantity: child?.quantity || 0,
              productPrice: child?.productPrice || 0,
              attributes: Array.isArray(child.attributes)
                ? child?.attributes?.map((attr) => ({
                    title: attr.title,
                    value: attr.value || 0,
                    // spicyLevel: attr.spicyLevel || 0,
                  }))
                : [],
            }))
          : [],
      }));

      setPlacedItems(placedItems);

      const cartOrders = JSON.parse(localStorage.getItem("cartOrders")) || {};
      const localItems =
        cartOrders[selectedTable.id]?.items?.filter((item) => !item.id) || [];

      const mergedItems = [
        ...placedItems.map((item) => ({
          ...item,
          isLocalItem: false, // API items are NOT new
        })),
        ...localItems.map((item) => ({
          ...item,
          isLocalItem: true, // Local cart items ARE new
        })),
      ];

      const mappedOrder = {
        orderId: response?.id,
        tableId: selectedTable?.id,
        orderRefrenceId: response?.orderRefrenceId,
        totalAmount: response?.totalAmount,
        discountAmount: response?.discountAmount,
        taxAmount: response?.taxAmount,
        grandTotal: response?.grandTotal,
        paymentStatus: response?.paymentStatus,
        orderStatus: response?.orderStatus,
        remarks: response?.remarks || "",
        items: mergedItems,
      };

      dispatch(setApiOrderData({ [selectedTable.id]: mappedOrder }));
    } catch (error) {
      console.error("Error fetching orders:", error);
      setError("Failed to fetch order.");
    } finally {
      setLoading(false);
    }
  };

  const fetchSection = async () => {
    try {
      const response = await SectionService.getList();
      setSectionData(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTable = async () => {
    setLoading(true);
    try {
      const response = await SectionService.detail(selectedSection?.value);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllTables = async () => {
    if (!shouldShowSections) {
      try {
        const tables = await TableService.getList();
        setAllTables(tables);
      } catch (error) {
        console.error("Error fetching tables:", error);
      }
    }
  };

  useEffect(() => {
    fetchAllTables();
  }, [shouldShowSections]);

  const resetModalState = () => {
    setIsModalOpen(false);
    setComplementary(false);
    setCount(1);
    setSelectedAttributes([]);
    setNotes("");
  };

  useEffect(() => {
    if (selectedTable?.id) {
      fetchOrder();
    }
  }, [selectedTable?.id]);

  useEffect(() => {
    fetchSection();
  }, []);

  useEffect(() => {
    if (selectedSection?.value) fetchTable();
  }, [selectedSection?.value]);

  useEffect(() => {
    if (selectedTable?.id) {
      localStorage.setItem("selectedTable", JSON.stringify(selectedTable));
      fetchOrder();
    }
  }, [selectedTable?.id]);
  useEffect(() => {
    const scrollContainer = document.querySelector(".product-scroll");

    if (!scrollContainer) return;

    let startY = 0;

    const touchStart = (e) => {
      startY = e.touches[0].clientY;
    };

    const touchMove = (e) => {
      const currentY = e.touches[0].clientY;
      const scrollTop = scrollContainer.scrollTop;

      if (scrollTop === 0 && currentY > startY) {
        // Prevent pull-to-refresh when scrolling down at top
        e.preventDefault();
      }
    };

    scrollContainer.addEventListener("touchstart", touchStart, {
      passive: true,
    });
    scrollContainer.addEventListener("touchmove", touchMove, {
      passive: false,
    });

    return () => {
      scrollContainer.removeEventListener("touchstart", touchStart);
      scrollContainer.removeEventListener("touchmove", touchMove);
    };
  }, []);

  return (
    <div className="container-xxl " style={{ minHeight: "100vh" }}>
      <Row>
        <Col
          md={7}
          lg={8}
          className=" d-lg-flex flex-lg-column"
          style={{
            height: "100vh",
          }}
        >
          <div className="sticky-top ">
            <SecondaryHeader
              toggleSidebar={toggleSidebar}
              sectionData={sectionData}
              setSelectedSection={setSelectedSection}
              selectedSection={selectedSection}
              data={data}
              setSelectedTable={setSelectedTable}
              selectedTable={selectedTable}
              kotListRef={kotListRef}
              setIsTableOpen={setIsTableOpen}
              isTableOpen={isTableOpen}
              kotList={kotList}
              setKotList={setKotList}
              allTables={allTables}
            />
            <div className="d-none d-md-block">
              <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
            </div>
          </div>
          <div
            className="product-scroll flex-grow-1 overflow-y-auto overflow-x-hidden"
            style={{ height: "calc(100vh - 10vh)" }}
          >
            <ProductPage
              setSelectedItem={setSelectedItem}
              selectedItem={selectedItem}
              setCount={setCount}
              setComplimentaryCount={setComplimentaryCount}
              count={count}
              setSelectedAttributes={setSelectedAttributes}
              selectedAttributes={selectedAttributes}
              handleAddToCart={handleAddToCart}
              setNotes={setNotes}
              notes={notes}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setComplementary={setComplementary}
              complementary={complementary}
              loading={loading}
              setSelectedTable={setSelectedTable}
              selectedTable={selectedTable}
              toggleOrderSummary={toggleOrderSummary}
              orderData={orderData}
              setSelectedChildAttributes={setSelectedChildAttributes}
              selectedChildAttributes={selectedChildAttributes}
            />
          </div>
        </Col>

        <Col
          md={5}
          lg={4}
          className="pt-lg-2 pt-md-2 d-none d-md-block"
          style={{
            height: "100vh",
            position: "sticky",
            top: 0,
            overflowY: "hidden",
            overflowX: "hidden",
          }}
        >
          <OrderSummary
            orderData={
              responseOrder[selectedTable?.id] ? responseOrder : orderData
            }
            setOrderId={setOrderId}
            orderId={orderId}
            data={data}
            fetchTable={fetchTable}
            sectionData={sectionData}
            setSelectedSection={setSelectedSection}
            selectedSection={selectedSection}
            fetchOrder={fetchOrder}
            setSelectedTable={setSelectedTable}
            selectedTable={selectedTable}
            handlePlaceOrder={handlePlaceOrder}
            billData={billsData}
            itemCounts={itemCounts}
            setItemCounts={setItemCounts}
            setIsQuantityChanged={setIsQuantityChanged}
            isQuantityChanged={isQuantityChanged}
            placedLoading={loading}
            placedItems={placedItems}
            fetchKot={fetchKot}
            allTables={allTables}
          />
        </Col>
      </Row>
      {isMobileOrder && (
        <OrderSummaryModal
          isOpen={isMobileOrder}
          toggle={toggleOrderSummary}
          orderData={
            responseOrder[selectedTable?.id] ? responseOrder : orderData
          }
          setOrderId={setOrderId}
          orderId={orderId}
          data={data}
          fetchTable={fetchTable}
          sectionData={sectionData}
          setSelectedSection={setSelectedSection}
          selectedSection={selectedSection}
          fetchOrder={fetchOrder}
          setSelectedTable={setSelectedTable}
          selectedTable={selectedTable}
          handlePlaceOrder={handlePlaceOrder}
          itemCounts={itemCounts}
          setItemCounts={setItemCounts}
          setIsQuantityChanged={setIsQuantityChanged}
          isQuantityChanged={isQuantityChanged}
          placedLoading={loading}
          fetchKot={fetchKot}
        />
      )}
    </div>
  );
};

export default PosLayout;
